import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'
import { Button } from '@wartek-id/button-v1'

import { GeneralNoticeState } from 'components/NoticeState'

import ForbiddenAccessImg from 'assets/icons/img-forbiden-access.svg'

const ForbiddenPage = () => {
  const router = useRouter()
  return (
    <div className="pt-11 max-w-md m-auto">
      <GeneralNoticeState
        showButton={false}
        containerClassNames="pt-10 pb-7 mx-7"
        title="Anda tidak termasuk peserta ujian"
        description={
          <>
            Pastikan akun <strong>belajar.id</strong> Anda sesuai dan Anda
            termasuk peserta Uji Kompetensi atau kunjungi Pusat Bantuan untuk
            bantuan selengkapnya.
          </>
        }
        icon={<ForbiddenAccessImg width={160} height={160} />}
        button={
          <div className="mt-5 space-y-3">
            <Button
              color="black"
              fullWidth
              onClick={() =>
                historyUtils.backToApp(() => router.replace('/home'))
              }
              size="lg"
              variant="solid"
            >
              Kembali ke Beranda
            </Button>
            <Button
              color="white"
              className="!bg-gray-10"
              fullWidth
              onClick={() => {
                window.open(
                  'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/articles/16600164533657-Tentang-Uji-Kompetensi-Pelaksana-Guru',
                  '_blank'
                )
              }}
              size="lg"
              variant="solid"
            >
              Ke Pusat Bantuan
            </Button>
          </div>
        }
      />
    </div>
  )
}

export default ForbiddenPage
